// extracted by mini-css-extract-plugin
export default {"card":"Card_card__lf-b2","cardContent":"Card_cardContent__Zvj+L","image":"Card_image__BCa7t","fields":"Card_fields__lyGKT","tech":"Card_tech__VJfwO"};